import type {
  ApiResponse,
  ISaveAttendance,
  ISaveSummaryStatus,
  ISaveRemoveStatus,
  ISaveSummaryComment,
  IClassUserReschedule,
  IMarkAttendancePayload,
} from '../types';
import routes from '@/config/routes';
import { v3Get, v3Post, v3Put } from '@/api/axios.instance.V3';
import { ITrainingList } from '@/store/types';

interface IClassUserSummaryPayloadObj {
  applicationId: number;
  userId: number;
  classId: number;
  statusLabel: string;
  data: { comments?: string; statusId?: number; classId: number };
}

const getClassesStatus = (Client: number | null | undefined): ApiResponse =>
  v3Get(`${routes.backendUrl.classes.getClassesStats + Client}`);

const getClassDetailsById = (classId: number | null | undefined): ApiResponse =>
  v3Get(`${routes.backendUrl.classes.getClassDetails + classId}`);

const getClassSummaryList = (classId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.classes.getClassSummaryList.replace('#ClassId', classId?.toString())}`);

const getClassRemovedList = (classId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.classes.getClassRemovedList.replace('#ClassId', classId?.toString())}`);

const getClassUserStatusList = (): ApiResponse => v3Get(`${routes.backendUrl.classes.getClassUserStatusList}`);

const getTrainingList = (classId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.classes.getTrainingList.replace('#ClassId', classId?.toString())}`);

const saveTrainingList = (payload: { classId: number; classUserTrainingSetupList: ITrainingList[] }): ApiResponse =>
  v3Post(`${routes.backendUrl.classes.setTrainingList}`, payload);

const setAttendance = (payload: ISaveAttendance[]): ApiResponse =>
  v3Post(`${routes.backendUrl.classes.setAttendance}`, payload);

const setSummaryComments = (payload: ISaveSummaryComment): ApiResponse => {
  return v3Put(`${routes.backendUrl.classes.setSummaryComments}`, payload);
};

const setSummaryStatus = (payload: ISaveSummaryStatus[]): ApiResponse => {
  return v3Put(`${routes.backendUrl.classes.setSummaryStatus}`, payload);
};

const setSummaryClassUser = (payload: IClassUserSummaryPayloadObj): ApiResponse => {
  const { applicationId, userId, data } = payload;
  return v3Post(`${routes.backendUrl.classes.setSummaryClassUser}${applicationId}/${userId}`, data);
};

const setRemoveStatus = (payload: ISaveRemoveStatus): ApiResponse => {
  return v3Post(`${routes.backendUrl.classes.setRemoveStatus}`, payload);
};

const registerRescheduleClass = (payload: IClassUserReschedule): ApiResponse => {
  return v3Post(`${routes.backendUrl.classes.registerRescheduleClass}`, payload);
};

const removeFromClassInitiatedBySP = (payload: ISaveSummaryStatus): ApiResponse => {
  return v3Put(`${routes.backendUrl.classes.removeFromClassInitiatedBySP}`, payload);
};

const markAttendance = (payload: IMarkAttendancePayload): ApiResponse => {
  return v3Post(`${routes.backendUrl.classes.markAttendanceClass}`, payload);
};

export const classesApi = {
  getClassesStatus,
  getClassDetailsById,
  getClassUserStatusList,
  setAttendance,
  getClassSummaryList,
  getClassRemovedList,
  setSummaryComments,
  setSummaryStatus,
  setSummaryClassUser,
  getTrainingList,
  saveTrainingList,
  setRemoveStatus,
  registerRescheduleClass,
  removeFromClassInitiatedBySP,
  markAttendance,
};
